import { Guardian } from '@xaamin/guardian';

Guardian.define('usuario.listar', (user) => {
  return user.can('usuario.listar');
});

Guardian.define('usuario.crear', (user) => {
  return user.can('usuario.crear');
});

Guardian.define('usuario.info', (user) => {
  return user.can('usuario.info');
});

Guardian.define('usuario.editar.informacion', (user) => {
  return user.can('usuario.editar.informacion');
});

Guardian.define('usuario.suspender', (user) => {
  return user.can('usuario.suspender');
});

Guardian.define('usuario.activar', (user) => {
  return user.can('usuario.activar');
});

Guardian.define('usuario.eliminar', (user) => {
  return user.can('usuario.eliminar');
});

Guardian.define('usuario.editar.permisos', (user) => {
  return user.can('usuario.editar.permisos');
});
